import { LMWorker } from '../types/lm-worker';
import { LMListComponent } from '@app/components';
import { Observable } from 'rxjs';
import { AppConstants } from '@utils/app.constants';

export class LMMultiListSaveWorker extends LMWorker {
  private readonly listComponents: LMListComponent[];

  constructor(listComponents: LMListComponent[]) {
    super();

    this.listComponents = listComponents;
  }

  protected has(i: number): boolean {
    return (i < this.listComponents.length);
  }

  protected get(i: number): LMListComponent {
    return this.listComponents[ i ];
  }

  protected run(i: number): Observable<boolean> {
    return new Observable<boolean>(observer => {
      const listComponent = this.listComponents[ i ];
      if (listComponent && listComponent.isModified()) {
        listComponent.runSaveAction(AppConstants.STANDARD_SAVE, observer);
      } else {
        observer.next(true);
        observer.complete();
      }
    });
  }
}
